import { render, staticRenderFns } from "./uOttawa1321Prelab1Q3Fr.vue?vue&type=template&id=8c1a691c&"
import script from "./uOttawa1321Prelab1Q3Fr.vue?vue&type=script&lang=js&"
export * from "./uOttawa1321Prelab1Q3Fr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VForm,VImg})
